import { OG_DEFAULT } from "@/seo/ogImages";
import type { BlogFrontmatter } from "./types";

// Kein eigenes Motiv -> Default-OG-Bild (1200x630) aus src/seo/ogImages.ts.
const OG_IMAGE = OG_DEFAULT.image;

export const frontmatter: BlogFrontmatter = {
  title: "HubSpot-Implementierung: Ablauf, Dauer & Kosten (2026)",
  slug: "hubspot-implementierung-kosten",
  description:
    "Was kostet eine HubSpot-Implementierung 2026? Ablauf, typische Dauer und Kostentreiber im Überblick, plus was ein Setup wirklich pipelinewirksam macht.",
  primaryKeyword: "hubspot implementierung kosten",
  secondaryKeywords: ["hubspot einführung", "hubspot onboarding kosten"],
  author: "tim",
  datePublished: "2026-07-04",
  dateModified: "2026-07-04",
  image: OG_IMAGE,
  imageAlt: "Illustration: Ablauf und Kosten einer HubSpot-Implementierung",
  internalLinks: ["/hubspot-revops", "/blog/was-ist-revops-revenue-operations"],
  draft: true,
  kurzGesagt:
    "Die Kosten einer HubSpot-Implementierung hängen von Umfang, Datenmigration und Prozesstiefe ab, nicht von der Lizenz allein. Entscheidend ist nicht das günstigste Setup, sondern eines, das Attribution und Pipeline messbar macht.",
  faq: [
    { q: "Was kostet eine HubSpot-Implementierung?", a: "Stub: wird ausgearbeitet." },
    { q: "Wie lange dauert die Einführung?", a: "Stub: wird ausgearbeitet." },
    { q: "Braucht man einen Partner oder geht es allein?", a: "Stub: wird ausgearbeitet." },
  ],
};

export default function Article() {
  return (
    <>
      <p>
        <em>Entwurf / Gliederung. Volltext folgt.</em>
      </p>
      <h2>Gliederung</h2>
      <ul>
        <li>Ablauf einer Implementierung in Phasen (Scoping, Setup, Migration, Enablement)</li>
        <li>Typische Dauer je nach Komplexität</li>
        <li>Kostentreiber: Datenmigration, Integrationen, Custom-Objekte, Reporting</li>
        <li>These: Ein Setup ohne Attribution ist verschenktes Budget</li>
        <li>Beispiel-Kostenrahmen für ein Mittelstands-Setup</li>
        <li>Woran man einen guten Implementierungspartner erkennt</li>
      </ul>
    </>
  );
}
